import { createApp } from 'vue';
import router from './router';
import App from './App.vue';
import './assets/css/animate.css'
import './assets/css/font-awesome.min.css'
import './assets/css/font.css'
import './assets/css/bootstrap.css'
import './assets/css/nestable.css'
import './assets/css/app.css'
import './assets/css/landing.css'
import './assets/css/ZMSoftware.css'
import './assets/css/modal.css'
import { SystemInformation } from './SystemInformation';

SystemInformation.Init(function()
{
  createApp(App).use(router).mount('#ZDMSEWApp');
});
